import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type StageSignoff = {
   signoff_requestid: number;
   stage_assessmentid: number;
   userid_requestee: number;
   created_at: number;
};

export type RespondToStageSignoffRequestResponse = {
   signoffResponse: StageSignoff;
};

export async function respondToStageSignoffRequest(
   signoff_requestid: number,
   response_value: boolean,
   response_feedback: string,
   { ...common }: CommonRequestOptions = {}
): Promise<RespondToStageSignoffRequestResponse> {
   return makeRequest('patch', `/courses/stage-sign-offs/responses`, {
      ...common,
      body: {
         signoff_requestid,
         response_value,
         response_feedback,
      },
   });
}
